import { render } from "./app_config.vue?vue&type=template&id=5c0a3ef5"
import script from "./app_config.vue?vue&type=script&lang=js"
export * from "./app_config.vue?vue&type=script&lang=js"

import "./app_config.vue?vue&type=style&index=0&id=5c0a3ef5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__